import { z } from 'zod';
import { GOOGLE_AGE_RANGES } from '../types/campaigns.types';

const locationTargetSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.enum(['country', 'city', 'region']),
  radius: z.number().optional(),
  radiusUnit: z.enum(['km', 'mi']).optional(),
});

const interestTargetSchema = z.object({
  id: z.string(),
  name: z.string(),
  category: z.string().optional(),
  type: z.enum(['USER_INTEREST', 'AUDIENCE', 'BEHAVIOR']).optional(),
});

export const audienceTargetingSchema = z.object({
  targetingConfig: z
    .object({
      locations: z.array(locationTargetSchema).min(1, 'Please add at least one location'),
      ageMin: z.number().min(13, 'Minimum age is 13').max(65, 'Maximum value is 65'),
      ageMax: z.number().min(18, 'Minimum value is 18').max(65, 'Maximum value is 65+'),
      // Google-only bracket for the Reach Forecast call; Meta keeps
      // ageMin/ageMax. Optional so Meta/Twitter/TikTok drafts validate fine
      // without it.
      googleAgeRange: z.enum(GOOGLE_AGE_RANGES).optional(),
      genders: z
        .array(z.enum(['male', 'female', 'all']))
        .min(1, 'Please select at least one gender option'),
      interests: z.array(interestTargetSchema),
      keywords: z.array(z.string()),
      // Drafts that predate the field are normalized to [] by the step's
      // defaultValues merge before this schema runs.
      behaviors: z.array(interestTargetSchema),
    })
    .refine((c) => c.ageMin <= c.ageMax, {
      message: 'Minimum age must be at or below the maximum age',
      path: ['ageMax'],
    }),
});

export type AudienceTargetingFormValues = z.infer<typeof audienceTargetingSchema>;
